import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {Link} from '../../../raw-components/link/link';
import {CyClass} from '../../../../../common/cy-classes';

export class MobileBurgerMenuComponent extends OrbitComponent<{}> {
  private _clickHandler = () => {
    this.services.analytics.sendAnalytics("Navigation", "NavBar", "Open_Burger");
    this.services.sideMenu.openMobileMenu();
  };

  render() {
    return (
      <>
      <Link className={'open-mobile-menu-icon'} onClick={this._clickHandler}>
        <i className={`${CyClass('cy-burger-button')} burger-icon`}/>
      </Link>
      <div className="navbar-separator"></div>
      </>
    );
  }
}
